import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    connections: {
      selectIds: [],
      filters: {},
      selectId: false
    }
  },
  mutations: {
    SET_CONNECTION_SELECT_IDS (store, ids) {
      store.connections.selectIds = ids
    },
    REMOVE_CONNECTION_SELECT_IDS (store, ids) {
      store.connections.selectIds = store.connections.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_CONNECTION_SELECT_ID (store, id) {
      store.connections.selectId = id
    },
    SET_CONNECTION_FILTERS (store, filters) {
      store.connections.filters = filters
    }
  },
  getters: {
    getConnections: (store, getters) => {
      return store.connections.selectIds.map((id) => {
        return getters['entities/connections/find'](id)
      })
    },
    getConnectionsFilters: (store, getters) => {
      return store.connections.filters
    },
    getConnection: (store, getters) => {
      return getters['entities/connections/find'](store.connections.selectId) || {}
    }
  },
  actions: {
    /*
    selectConnections
    */
    selectConnections ({commit, dispatch, getters, state}, filters) {
      return dispatch('getConnections', filters)
      .then((response) => {
        commit('SET_CONNECTION_FILTERS', filters)
        commit('SET_CONNECTION_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectConnections
    */
    refreshSelectConnections ({commit, dispatch, getters, state}) {
      return dispatch('selectConnections', getters.getConnectionsFilters)
    },
    /*
    getConnections
    aggregated list of the account connections
    */
    getConnections ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/connections`, {params: filters})
      .then((response) => {
        return dispatch('entities/connections/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.connections || []
      })
    },
    /*
    createConnection
    cria a conexão de uma integração qualquer (ex.: indeed, whatsapp)
    */
    createConnection ({commit, dispatch, getters, state}, {integration, data}) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/connections/${integration}`, data)
      .then((response) => {
        return dispatch('entities/connections/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.connections[0]
      })
    },
    /*
    updateConnection
    */
    updateConnection ({commit, dispatch, getters, state}, {integration, id, data}) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/connections/${integration}/${id}`, data)
      .then((response) => {
        return dispatch('entities/connections/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.connections[0]
      })
    },
    /*
    deleteConnection
    */
    deleteConnection ({commit, dispatch, getters, state}, {integration, id}) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/connections/${integration}/${id}`)
      .then((response) => {
        commit('REMOVE_CONNECTION_SELECT_IDS', [id])
        dispatch('entities/connections/delete', id)
        return {}
      })
    },
    /*
    getWhatsappTemplates
    */
    getWhatsappTemplates ({commit, dispatch, getters, state}, {id, filters}) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/connections/whatsapp/${id}/capabilities/templates`, {params: filters})
      .then((response) => {
        return response.data
      })
    },
    /*
    refreshWhatsappTemplates
    ressincroniza os templates com a meta
    */
    refreshWhatsappTemplates ({commit, dispatch, getters, state}, id) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/connections/whatsapp/${id}/capabilities/templates/refresh`)
      .then((response) => {
        return response.data
      })
    },
    /*
    createWhatsappTemplate
    */
    createWhatsappTemplate ({commit, dispatch, getters, state}, {id, data}) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/connections/whatsapp/${id}/capabilities/templates`, data)
      .then((response) => {
        return response.data
      })
    },
    /*
    deleteWhatsappTemplate
    */
    deleteWhatsappTemplate ({commit, dispatch, getters, state}, {id, name}) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/connections/whatsapp/${id}/capabilities/templates/${name}`)
      .then((response) => {
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/connections.js